module.exports = __webpack_public_path__ + "static/img/FR@2x.940f6cc7.jpg";